export interface IWarehouseAdminOptionData {
    id: number|string;
    name: string;
}

export default class WarehouseAdminOptionData {
    public id: number|string;
    public name: string;

    constructor(data: IWarehouseAdminOptionData) {
        this.id = data.id;
        this.name = data.name;
    }
}